import { exposed, fromNode, ViewModel } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import type { ElementNode } from './TypedNode'
import type { TRecord } from '@rehaje/shared'

export class ElementModel extends ViewModel {
  @reactive()
  __r_props_version = 0

  @exposed()
  @fromNode()
  @reactive()
  hidden = false

  @exposed()
  @fromNode()
  @reactive('deep')
  props: TRecord = {}

  constructor(node: ElementNode) {
    super(node)
    this.addWatch(
      (event) => {
        if (event.path[0] === 'props') {
          event.addEffect(() => {
            this.__r_props_version++
          })
        }
      },
      {
        async: false
      }
    )
  }

  getComponentProps(): TRecord {
    void this.__r_props_version
    const props = this.props
    return { ...props, style: { ...props.style } }
  }

  setHidden(hidden: boolean) {
    this.hidden = hidden
  }
}
